export enum AppEvents {
  displayApplicationNavigationBars = "displayNavbars",
  hideApplicationNavigationBars = "hideNavbars",
  buildSidebarNavidationMenu = "buildSidebarMenu",
  atualizarListagemAtualSimilaridades = "atualizarListagemAtualSimilaridades",
}
